import { combineReducers } from 'redux';

import application from 'wpt-duck-application';
import env from 'wpt-duck-env';
import hashtags from 'wpt-duck-hashtags';

const reducers = combineReducers({
  application,
  env,
  hashtags,
});

export default reducers;
